import { Stack, Text, Group, Skeleton } from '@mantine/core';
import cn from 'clsx';
import BigNumber from 'bignumber.js';
import { formatDecimal } from 'src/utils';
import { useProtocolInfo } from 'src/api';

const SHOW_STATS = import.meta.env.VITE_SHOW_STATS === 'true';
const SHOW_APY = import.meta.env.VITE_SHOW_APY === 'true';

export function Stats() {
  const { protocolInfo, isLoadingProtocolInfo } = useProtocolInfo({
    enabled: SHOW_STATS,
  });

  if (!SHOW_STATS) {
    return null;
  }

  return (
    <Group
      justify="space-between"
      className="flex-col gap-8 lg:flex-row lg:gap-5"
    >
      <Stack
        gap={10}
        align="center"
        className="flex-grow border-r-[rgba(138,145,158,0.30)] border-[0px] lg:border-r border-solid"
      >
        <Text size="md">aPriori TVL</Text>
        {isLoadingProtocolInfo || !protocolInfo ? (
          <Skeleton w={140} h={53} />
        ) : (
          <Text size="xl" variant="gradient">
            {formatDecimal(BigNumber(protocolInfo?.tvl || 0).div(1e18), {
              thousandsToK: false,
            })}{' '}
            MON
          </Text>
        )}
      </Stack>

      {SHOW_APY && (
        <Stack
          gap={10}
          align="center"
          className="flex-grow border-r-[rgba(138,145,158,0.30)] border-[0px] lg:border-r border-solid"
        >
          <Text size="md">APY</Text>
          {isLoadingProtocolInfo || !protocolInfo ? (
            <Skeleton w={140} h={53} />
          ) : (
            <Text size="xl" variant="gradient">
              {protocolInfo?.apr}%
            </Text>
          )}
        </Stack>
      )}

      <Stack gap={10} align="center" className="flex-grow">
        <Text size="md">aprMON Holders</Text>
        {isLoadingProtocolInfo || !protocolInfo ? (
          <Skeleton w={140} h={53} />
        ) : (
          <Text size="xl" variant="gradient">
            {formatDecimal(protocolInfo?.stakers || 0, {
              thousandsToK: false,
            })}
          </Text>
        )}
      </Stack>
    </Group>
  );
}

Stats.APY = function StatsApy() {
  const { protocolInfo, isLoadingProtocolInfo } = useProtocolInfo({
    enabled: SHOW_STATS,
  });

  if (!SHOW_STATS || !SHOW_APY) return null;

  return (
    <span
      className={cn(
        'h-[40px] leading-[40px] px-4',
        'bg-primarypurple/50 rounded-[90px] text-xs font-[700]',
        isLoadingProtocolInfo && 'animate-pulse'
      )}
    >
      {isLoadingProtocolInfo ? (
        <span className="block w-16" />
      ) : (
        <>{protocolInfo?.apr}% APY</>
      )}
    </span>
  );
};
